import React from "react";
import DiagnosticPage from "@components/Pages/DiagnosticPage/DiagnosticPage";

export default function Greining() {
    return <DiagnosticPage />;
}

export async function getStaticProps({ locale }) {
    return {
        props: {
            messages: (await import(`../locales/${locale}.json`)).default,
        },
    };
}
